module.exports = __webpack_public_path__ + "img/norway-stomach-cancer-female.86936a7d.png";